/* global I18n  */

import helpscoutLoader from "./helpscout_loader"
import rollbarHelper from "./rollbar_helper"
import objectChunker from "./object_chunker"
import _ from "lodash"

export default (params = {}, gon = window.gon) => {
  const Beacon = helpscoutLoader()
  Beacon("config", {
    color: "#0099FF",
    labels: I18n.t("js.helpscout.site.labels"),
    display: {
      style: "manual",
      position: "right"
    }
  })
  Beacon("navigate", getBeaconSlide(params))
  Beacon("session-data", getPayload(gon, params))
  Beacon("prefill", {subject: getSubject(params)})
  return Beacon
}

function getBeaconSlide(params) {
  if (params?.ask) return "/ask/message/"
  // feedback flags should let you enter feedback immediately
  if (params?.contentFeedback) return "/ask/message/"

  return "/answers/"
}

function getSubject(params) {
  if (!params.name) return I18n.t("js.helpscout.feedback")
  return I18n.t("js.helpscout.feedback_from", {name: params.name})
}

function getPayload(gon, params = {}) {
  let payload = _.defaults(params, getGonPayload(gon), getErrorPayload())
  payload = objectChunker(payload, 10000)
  payload = validateNumberOfPayloadAttributes(payload)
  return payload
}

function getGonPayload(gon) {
  const omittingAttrs = ["consumedContent"]
  return {gon: JSON.stringify(_.omit(gon, omittingAttrs))}
}

function getErrorPayload() {
  const payload = _.omit(
    rollbarHelper.getErrorPayload() || {},
    // payload object can only be one level deep
    // and we don't need person, client
    // quiz_skeleton is only the initial skeleton, we get the current
    // quiz structure from the context (training session)
    ["person", "client", "quiz_skeleton"]
  )
  if (payload.context) {
    const context = JSON.parse(payload.context)
    payload.quizDigest = context.quizDigest
    payload.sessionSlug = context.session?.slug
    payload.startTime = context.startTime
    payload.duration = context.duration
    payload.currentIndex = context.currentIndex
    payload.exercises = JSON.stringify(context.exercises)
    if (context.currentExercise) {
      payload.currentExerciseUuid = context.currentExercise[0].uuid
      payload.currentExercise = JSON.stringify(context.currentExercise)
    }
    payload.stats = JSON.stringify(context.stats)
    delete payload.context
  }
  return payload
}

function validateNumberOfPayloadAttributes(payload) {
  // Helpscout doesn't allow more then 20 attributs next to name and email
  // it looks like signature and also the message itself is also counted
  const keys = Object.keys(payload)
  if (keys.length <= 20) return payload
  // remove exercises attributes which were added by the object_chunker
  for (const key of Object.keys(payload)) {
    if (key.match("exercises")) delete payload[key]
  }

  if (Object.keys(payload).length <= 20) return payload
  rollbarHelper.sendErrorMsg("Too many attributes for helpscout beacon!", {
    payload: JSON.stringify(payload)
  })
  for (const key of keys.slice(20)) delete payload[key]
  return payload
}
